import React, {ComponentType, useMemo} from "react";
import {useSelector} from "react-redux";

import {flex, flexDirection, gap, pt} from "@pg-design/helpers-css";
import {IIcon} from "@pg-design/icons-module";
import {rpAppLink} from "@pg-mono/rp-routes";

import {IRPStore} from "../../app/rp_reducer";
import {useSearchGtm} from "../hooks/use_search_gtm";
import {gtmSearch} from "../tracking/events";
import {resultsList} from "./atoms/atoms";
import {ResultsInfo} from "./atoms/ResultsInfo";
import {ResultsListItem} from "./atoms/ResultsListItem";

interface Link {
    label: string;
    url: string;
    icon?: ComponentType<IIcon>;
}

interface IProps {
    activeItemId: number | null;
    links: Link[];
}

export const SearchLinksDropdownList = (props: IProps) => {
    const searchText = useSelector((state: IRPStore) => state.search.formValues.search.label) as string;
    const {gtmLabel} = useSearchGtm();

    const filteredLinkstList = useMemo(() => {
        return props.links.filter((item) => item.label.toLowerCase().includes(searchText?.toLowerCase() || ""));
    }, [searchText, props.links]);

    if (!filteredLinkstList.length) {
        return (
            <ul css={resultsList}>
                <ResultsInfo title="Niestety nic nie znaleźliśmy" text="Zmień parametry wyszukiwania" />
            </ul>
        );
    }
    const allHolidayResultsHandler = () => {
        window.location.href = rpAppLink.investmentOffer.investmentCategory.base({category: "apartamenty-wakacyjne"});
    };
    return (
        <ul css={resultsList}>
            <ResultsListItem title="Wszystkie wakacyjne lokalizacje" onClick={allHolidayResultsHandler} />

            {filteredLinkstList.map((item, idx) => {
                const Icon = item.icon;
                return (
                    <ResultsListItem
                        key={idx}
                        idx={idx}
                        activeItemId={props.activeItemId}
                        title={
                            <>
                                {!!Icon && <Icon wrapperSize="2.4" wrapperColor="transparent" size="2.4" />}
                                {item.label}
                            </>
                        }
                        href={item.url}
                        onClick={() => {
                            gtmSearch(item.label, "Wakacyjne", gtmLabel);
                        }}
                        titleCss={[flex("center"), flexDirection("row"), gap(0.5), pt(1)]}
                        titleAs="div"
                    />
                );
            })}
        </ul>
    );
};
import React, {ComponentType, useMemo} from "react";
import {useSelector} from "react-redux";

import {flex, flexDirection, gap, pt} from "@pg-design/helpers-css";
import {IIcon} from "@pg-design/icons-module";
import {rpAppLink} from "@pg-mono/rp-routes";

import {IRPStore} from "../../app/rp_reducer";
import {useSearchGtm} from "../hooks/use_search_gtm";
import {gtmSearch} from "../tracking/events";
import {resultsList} from "./atoms/atoms";
import {ResultsInfo} from "./atoms/ResultsInfo";
import {ResultsListItem} from "./atoms/ResultsListItem";

interface Link {
    label: string;
    url: string;
    icon?: ComponentType<IIcon>;
}

interface IProps {
    activeItemId: number | null;
    links: Link[];
}

export const SearchLinksDropdownList = (props: IProps) => {
    const searchText = useSelector((state: IRPStore) => state.search.formValues.search.label) as string;
    const {gtmLabel} = useSearchGtm();

    const filteredLinkstList = useMemo(() => {
        return props.links.filter((item) => item.label.toLowerCase().includes(searchText?.toLowerCase() || ""));
    }, [searchText, props.links]);

    if (!filteredLinkstList.length) {
        return (
            <ul css={resultsList}>
                <ResultsInfo title="Niestety nic nie znaleźliśmy" text="Zmień parametry wyszukiwania" />
            </ul>
        );
    }
    const allHolidayResultsHandler = () => {
        window.location.href = rpAppLink.investmentOffer.investmentCategory.base({category: "apartamenty-wakacyjne"});
    };
    return (
        <ul css={resultsList}>
            <ResultsListItem title="Wszystkie wakacyjne lokalizacje" onClick={allHolidayResultsHandler} />

            {filteredLinkstList.map((item, idx) => {
                const Icon = item.icon;
                return (
                    <ResultsListItem
                        key={idx}
                        idx={idx}
                        activeItemId={props.activeItemId}
                        title={
                            <>
                                {!!Icon && <Icon wrapperSize="2.4" wrapperColor="transparent" size="2.4" />}
                                {item.label}
                            </>
                        }
                        href={item.url}
                        onClick={() => {
                            gtmSearch(item.label, "Wakacyjne", gtmLabel);
                        }}
                        titleCss={[flex("center"), flexDirection("row"), gap(0.5), pt(1)]}
                        titleAs="div"
                    />
                );
            })}
        </ul>
    );
};
